<template>
    <div id="tradeGroupMain">
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Aggregated Trading Group</div>
                </div>
                <br>
            </div>
            <div class="e-card-content tradeGroupForm">
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-textbox id='groupName' name="groupName" v-model="data.tradingGroupName" width="60%" floatLabelType="Auto" :enabled="isEditable" placeholder="Group Name"></ejs-textbox>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist ref='dplStates' id="state" name="state" width="60%" :dataSource='states' v-model="data.stateId" :enabled="isEditable" :select="onStateChange" :fields="{text: 'stateName', value: 'stateId' }" placeholder="Country" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="utility" name="utility" ref='dplUtility' width="60%" :dataSource='utilities' :enabled="isEditable" v-model="selectedUtilityId" :fields="{text: 'name', value: 'id' }" placeholder="Utility" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="supplier" ref='dplSuppliers' name="supplier" width="60%" :dataSource='suppliers' :enabled="isEditable" v-model="selectedSupplierId" :select="onSupplierChange" :fields="{text: 'name', value: 'id' }" placeholder="Supplier" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group required-input">
                        <ejs-dropdownlist id="status" name="status" ref='dplStatus' width="60%" :dataSource='status' :select='onStatusChange' :enabled="true" v-model="data.status" :fields="{text: 'name', value: 'id' }" placeholder="Status" floatLabelType='Auto' :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                        <ejs-button cssClass='e-flat' v-on:click.native='btnAddContract' :disabled="!isEditable">Add Contract</ejs-button>
                    </div>
                    <div class="form-group col-md-6 d-flex justify-content-center input-group">
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="e-card">
            <div class="e-card-header">
                <div class="e-card-header-caption">
                    <div class="e-card-header-title">Contracts</div>
                </div>
            </div>
            <div class="e-card-content">
                <div class="form-row">
                    <ejs-grid ref='grid'
                              :toolbar='toolbar'
                              :editSettings='editSettings'
                              :dataSource='contractData'
                              :allowFiltering='true'
                              :allowPaging='true'
                              :allowResizing='true'
                              :allowReordering='true'
                              :allowSorting='true'
                              :pageSettings='pageSettings'
                              :filterSettings='filterOptions'
                              :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete'>
                        <e-columns>
                            <e-column field='contractId' headerText='Id' :isPrimaryKey='true' :visible='true'></e-column>
                            <e-column field='contractName' headerText='Contract Name' width=160></e-column>
                            <e-column field='clientName' headerText='Client' width=120></e-column>
                            <e-column field='companyName' headerText='Company' width=120></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
                <div class="clientButtons">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                        </div>
                        <div style="text-align: right; margin-top:20px;" class="form-group col-md-6">
                            <ejs-button v-if="canSave" style="margin-right:10px" cssClass="e-primary" v-on:click.native='btnSaveClick'>Save</ejs-button>
                            <ejs-button v-on:click.native='btnBackClick'>Back</ejs-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ejs-dialog id='dialog' ref="templateDialog" :visible="false" :isModal="true" :header='header' :width='width' :showCloseIcon='true' :buttons='buttons'>
            <div class="form-row">
                <ejs-autocomplete  ref="acContracts" :dataSource='contractSource' :showPopupButton="true" :fields="{text: 'name', value: 'id'}" :placeholder="waterMarkName"  :change="acNameChange" :actionComplete="acNameActionComplete" :actionBegin="acNameActionBegin">
                </ejs-autocomplete>
            </div>
            <div class="form-row" style="margin-top:15px">
                <ejs-autocomplete  ref="acContractsId" :dataSource='contractSource' :showPopupButton="true" :fields="{text: 'id', value: 'id'}" :placeholder="waterMarkID"  :change="acIdChange" :actionBegin="acIDActionBegin">
                </ejs-autocomplete>
            </div>
        </ejs-dialog>
        <div id="saveFormSpinner"></div>
    </div>

</template>

<script>
    import Vue from "vue";
    import { DropDownListPlugin, AutoCompletePlugin  } from "@syncfusion/ej2-vue-dropdowns";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
    import { CheckBoxPlugin, ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { NumericTextBoxPlugin, UploaderPlugin, TextBoxPlugin, FormValidator } from "@syncfusion/ej2-vue-inputs";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import SyncHelper from '../../common/syncfusion';
    import apis from '../../common/network';
    import gridOptions from '../../common/gridOptions';
    import { Query } from '@syncfusion/ej2-data';
    import store from '../../store';
    import { isNullOrUndefined } from '@syncfusion/ej2-base';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import RMErrorType from '@/common/errorTypes';

    Vue.use(DialogPlugin);
    Vue.use(DatePickerPlugin);
    Vue.use(NumericTextBoxPlugin);
    Vue.use(DropDownListPlugin);
    Vue.use(CheckBoxPlugin);
    Vue.use(ButtonPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    Vue.use(AutoCompletePlugin);

    export default {
        name: 'TradingGroupForm',
        created() {
            if (!this.$route.params.tradingGroupId) return;
            apis.protectedApi(`tradinggroup/${this.$route.params.tradingGroupId}`)
                .then(response => {
                    this.data = response.data;
                    this.populateSuppliers(this.data.stateId)
                    this.populateUtilities(this.data.supplierId);
                    this.contractData = response.data.contracts;
                }).catch(e => {
                    DialogUtility.alert({
                        title: 'Alert Dialog',
                        content: e.response.data.message,
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                });
        },
        mounted() {
            this.tradeGroupForm = new FormValidator(".tradeGroupForm", this.options);

            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading',
               
            });
        },
        data() {
            return {
                data: {},
                suppliers: [],
                contractSource: SyncHelper.getDataManager(`utils/searchContracts`),
                pageSettings: gridOptions.pageSettings,
                filterOptions: gridOptions.filterSettings,
                contractData: [],
                toolbar: ['Delete'],
                editSettings: {
                    allowDeleting: this.$route.params.tradingGroupId ? false : true,
                    showDeleteConfirmDialog: true,
                },
                selectedSupplierId: null,
                selectedUtilityId: null,
                riskManagerId: null,
                clientId: null,
                startDate: null,
                endDate: null,
                waterMarkName: "Contract Name",
                waterMarkID: "Contract ID",
                clientId: null,
                utilities: [],
                tradeGroupForm: '',
                isEditable: this.$route.params.tradingGroupId && this.$store.state.permissions["Permissions.TradingGroup.Create"] ? false : true,
                canSave: this.$store.state.permissions["Permissions.TradingGroup.Create"],
                status: [
                    { "name": "Active", "id": true },
                    { "name": "Inactive", "id": false }
                ],
                width: '335px',
                height: '350px',
                header: 'Add Contract',
                buttons: [
                    {
                        click: this.dlgButtonSelectClick,
                        buttonModel: { content: 'Select', isPrimary: true }
                    },
                    {
                        click: this.dlgButtonCancelClick,
                        buttonModel: { content: 'Cancel' }
                    }
                ],
                options: {
                    //Initialize the CustomPlacement.
                    customPlacement: function (inputElement, errorElement) {
                        inputElement = inputElement.closest('.form-group');
                        errorElement.style.width = '60%'
                        inputElement.appendChild(errorElement);
                    },
                    rules: {
                        'state': {
                            required: true
                        },
                        'utility': {
                            required: true
                        },
                        'supplier': {
                            required: true
                        },
                        'status': {
                            required: true
                        }
                    }
                },
                allowFiltering: true
            }
        },
        methods: {
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            onStatusChange: function (e) {
                if (e.itemData.name == "Inactive") {

                    DialogUtility.alert({
                        title: 'Alert Dialog',
                        content: 'If trading group goes inactive all its contracts will be inactive!',
                        position: { X: 700, Y: 200 },
                        showCloseIcon: true,
                        closeOnEscape: true,
                        animationSettings: { effect: 'Zoom' },
                        zIndex: 1100
                    });
                }
            },
            populateSuppliers: function (stateId, isChangeEvent) {
                apis.protectedApi(`utils/suppliers?stateId=${stateId}`)
                    .then(response => {
                        this.suppliers = response.data;
                    
                        setTimeout(() => {
                            this.selectedSupplierId = isChangeEvent ? null : this.data.supplierId;
                        }, 1000)
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog("Something went wrong, please contact support.");
                    });
            },
            populateUtilities: function (supplierId, isChangeEvent) {
                apis.protectedApi(`utils/utilitiesForSupplier?supplierId=${supplierId}`)
                    .then(response => {
                        this.utilities = response.data;
                        setTimeout(() => {
                            this.selectedUtilityId = isChangeEvent ? null : this.data.utilityTypeId;
                        }, 1000)
                      
                    }).catch(e => {
                        if (e.response)
                            this.showErrorDialog("Something went wrong, please contact support.");
                    });
            },
            acNameActionBegin: function (e) {
                e.query = new Query()
                    .addParams("stateId", this.$refs.dplStates.ej2Instances.value)
                    .addParams("utilityTypeId", this.$refs.dplUtility.ej2Instances.value)
                    .addParams("supplierId", this.$refs.dplSuppliers.ej2Instances.value)
                    .addParams("userId", this.$store.state.loggedInUserId)
                    .addParams("searchField", "name")
            },
            acNameActionComplete: function (autoCompleteContractSource) {
                if (autoCompleteContractSource.result && autoCompleteContractSource.result.length > 0 && this.$refs.grid.ej2Instances.dataSource.length > 0) {
                    var exists = this.$refs.grid.ej2Instances.dataSource.map(ds => {
                        let res = {};
                        res[ds.contractId] = true;
                        return res;
                    });
                    var filtered = [], accsLength = autoCompleteContractSource.result.length;
                    for (var i = 0; i < accsLength; i++) {
                        if (exists.some(e => e[autoCompleteContractSource.result[i].id])) continue;
                        exists[autoCompleteContractSource.result[i].id] = true;
                        filtered.push(autoCompleteContractSource.result[i]);
                    }

                    autoCompleteContractSource.result = filtered;
                }
            },
            acIDActionBegin: function (e) {
                e.query = new Query()
                    .addParams("stateId", this.$refs.dplStates.ej2Instances.value)
                    .addParams("utilityTypeId", this.$refs.dplUtility.ej2Instances.value)
                    .addParams("supplierId", this.$refs.dplSuppliers.ej2Instances.value)
                    .addParams("userId", this.$store.state.loggedInUserId)
                    .addParams("searchField", "id")
            },
            onStateChange: function (e) {
                this.populateSuppliers(e.itemData.stateId, true);
            },
            onSupplierChange: function (e) {
                this.populateUtilities(e.itemData.id, true);
            },
            btnAddContract: function (e) {
                this.tradeGroupForm.addRules('groupName', { required: false });
                this.tradeGroupForm.addRules('status', { required: false });
                let isValid = this.tradeGroupForm.validate();
                if (!isValid) return;

                this.$refs.acContractsId.ej2Instances.clear();
                this.$refs.acContractsId.ej2Instances.enabled=true;
                this.$refs.acContracts.ej2Instances.clear();
                this.$refs.acContracts.ej2Instances.enabled = true;
                this.$refs.templateDialog.show();
            },
            dlgButtonCancelClick: function (e) {
                this.$refs.templateDialog.hide();
            },
            dlgButtonSelectClick: function (e) {
                let contractId;
                let existingContractIds;
                this.$refs.grid.ej2Instances.showSpinner();
                if (this.$refs.acContracts.ej2Instances.enabled && this.$refs.acContracts.ej2Instances.value) {
                    contractId = this.$refs.acContracts.ej2Instances.value
                } else if (this.$refs.acContractsId.ej2Instances.enabled && this.$refs.acContractsId.ej2Instances.value) {
                    contractId = this.$refs.acContractsId.ej2Instances.value
                }
                if (!contractId) {
                    this.showErrorDialog("Please select contract by Name or ID");
                    return;
                }
                if (this.$refs.grid.ej2Instances.dataSource.length > 0) {
                    existingContractIds = this.$refs.grid.ej2Instances.dataSource;
                    var existingGridContractIds = new Array();

                    for (var i = 0; i < existingContractIds.length; i++) {
                        existingGridContractIds.push(existingContractIds[i].contractId);
                    }

                } 
                apis.protectedApi.post(`contract/validate?existingContractIds=${existingGridContractIds}&newContractId=${contractId}`)
                    .then(response => {
                        if (response.data) {
                            if (response.data.isValid) {
                                apis.protectedApi(`contract/overview?contractId=${contractId}`)
                                    .then(response => {
                                        if (response.data) {
                                            this.riskManagerId = response.data.riskManagerId;
                                            this.startDate = response.data.startDate;
                                            this.endDate = response.data.endDate;
                                            this.clientId = response.data.clientId;
                                            this.$refs.grid.ej2Instances.dataSource.push(response.data);
                                            this.$refs.templateDialog.hide();
                                            this.$refs.grid.ej2Instances.hideSpinner();
                                            this.$refs.grid.ej2Instances.refresh();
                                        }
                                    }).catch(e => {
                                        this.$refs.templateDialog.hide();
                                        this.$refs.grid.ej2Instances.hideSpinner();
                                        this.showErrorDialog(e.response.data.message != undefined ? e.response.data.message : "Error invoking service,please contact support");
                                    });
                            } else {
                                let dialogContent;
                                response.data.errors.forEach(function (item) {
                                    dialogContent = `<li>${item}</li>`;
                                });
                                this.$refs.templateDialog.hide();                             
                                this.showErrorDialog(`$<ul>${dialogContent}</ul>`);
                                this.$refs.grid.ej2Instances.hideSpinner();
                            }      
                        }
                    }).catch(e => {
                        this.$refs.templateDialog.hide();
                        this.$refs.grid.ej2Instances.hideSpinner();
                        if (e.response)
                            this.showErrorDialog(e.response.data.message);
                    });
            },
            acNameChange: function (e) {
                if (e.itemData) {
                    this.$refs.acContractsId.ej2Instances.enabled = false;
                } else {
                    this.$refs.acContractsId.ej2Instances.enabled = true;
                }        
            },
            acIdChange: function (e) {
                if (e.itemData) {
                    this.$refs.acContracts.ej2Instances.enabled = false;
                } else {
                    this.$refs.acContracts.ej2Instances.enabled = true;
                }
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
            btnSaveClick: function (e) {
                if (this.data.tradingGroupId) {
                    this.updateATG();
                } else {
                    this.createATG();
                }
            },

            createATG: function () {
                showSpinner(document.getElementById('mainSpinner'));
                this.tradeGroupForm.addRules('groupName', { required: true });
                this.tradeGroupForm.addRules('status', { required: true });

                let isValid = this.tradeGroupForm.validate();
                if (!isValid) {
                    hideSpinner(document.getElementById('mainSpinner'));
                    return;
                }
                if (this.$refs.grid.ej2Instances.dataSource.length < 2) {
                    hideSpinner(document.getElementById('mainSpinner'));
                    this.showErrorDialog("Add at least two contracts.");
                    return;
                }
                this.data.riskManagerId = this.riskManagerId;
                this.data.utilityTypeId = this.selectedUtilityId;
                this.data.supplierId = this.selectedSupplierId;
                this.data.contracts = this.$refs.grid.ej2Instances.dataSource;
                this.data.startDate = this.startDate;
                this.data.endDate = this.endDate;
                this.data.clientId = this.clientId;
                apis.protectedApi.post(`tradinggroup`, this.data)
                    .then(response => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        let message = { title: 'Success!', content: 'Contract group is created successfully', cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                        this.$router.push({ name: "TradingGroups" });
                    }).catch(e => {
                        if (e.response) {
                            hideSpinner(document.getElementById('mainSpinner'));
                            gridOptions.errorAlert(e.response.data.message);
                        }
                    });
            },
            updateATG: function () {
                showSpinner(document.getElementById('mainSpinner'));
                this.tradeGroupForm.addRules('groupName', { required: true });
                this.tradeGroupForm.addRules('status', { required: true });

                let isValid = this.tradeGroupForm.validate();
                if (!isValid) return;

                if (this.$refs.grid.ej2Instances.dataSource.length < 2) {
                    hideSpinner(document.getElementById('mainSpinner'));
                    this.showErrorDialog("Add at least two contracts.");
                    return;
                }
                apis.protectedApi.put(`tradinggroup`, this.data)
                    .then(response => {
                        hideSpinner(document.getElementById('mainSpinner'));
                        let message = { title: 'Success!', content: 'Trading group is updated successfully', cssClass: 'e-toast-success' };
                        this.$root.$emit('showToast', message);
                        this.$router.push({ name: "TradingGroups" });
                    }).catch(e => {
                        if (e.response) {
                            hideSpinner(document.getElementById('mainSpinner'));
                            gridOptions.errorAlert(e.response.data.message);
                        }
                    });
            },
            btnBackClick: function (e) {
                this.$router.push({ name: "TradingGroups" });
            }
        },
        computed: {
            states: () => {
                return SyncHelper.getDataManager("utils/states")
            },
            selectedStateId: function() {
                return this.$refs.dplStates.ej2Instances.value
            },
            getSelectedUtilityId: function () {
                return this.$refs.dplUtility.ej2Instances.value;
            },
            getSelectedSupplierId: function () {
                return this.$refs.dplSuppliers.ej2Instances.value;
            },
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    }
</script>

<style scoped>

    .e-btn.e-flat {
        border: 1px solid;
        border-color: #ced4da;
        background-color: #6d6d6d;
        color: white;
    }
        .e-btn.e-flat:hover {
            border: 1px solid;
            border-color: #575757;
            background-color: #5d5d5d;
            color: white;
        }

   
</style>
<style>
    .e-input-group {
        height: 30px;
    }

    .required-input .e-float-input.e-control-wrapper .e-float-text::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }
</style>